export const sealColor = state => state.sealColor;
export const sealType = state => state.sealType;
export const sealShowUrl = state => state.sealShowUrl;
export const templateSearchContent = state => state.templateSearchContent;
export const templateCurrentPage = state => state.templateCurrentPage;
export const batchList = state => state.batchList;
export const filesUploadOther = state => state.filesUploadOther;



// WEBPACK FOOTER //
// ./src/pages/admin/store/getters.js